"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClientSide = exports.onNextFrame = exports.needChangeSide = exports.dropdownVisible = exports.visibleInPage = void 0;

/**
 * We can check if the element is in the page.
 * @param element
 * @param bottomOffset
 * @returns {boolean}
 */
var visibleInPage = function visibleInPage(element) {
  var bottomOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;

  if (!element) {
    return false;
  }

  var bounding = element.getBoundingClientRect();
  var bottom = bounding.bottom + bottomOffset <= document.documentElement.clientHeight;
  var top = bounding.height + bottomOffset <= bounding.top;
  return bounding.top >= 0 && bounding.left >= 0 && (!bottom && !top || bottom);
};

exports.visibleInPage = visibleInPage;

var dropdownVisible = function dropdownVisible(container) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!container) {
    return false;
  }

  var bounding = container.getBoundingClientRect();

  if (element) {
    return document.documentElement.clientHeight - bounding.bottom >= bounding.height + element.current.clientHeight || !(bounding.top > 0);
  }

  return document.documentElement.clientHeight - bounding.bottom >= 0 || !(bounding.bottom - bounding.top >= bounding.height);
};

exports.dropdownVisible = dropdownVisible;

var needChangeSide = function needChangeSide(element) {
  if (!element) {
    return false;
  }

  var bounding = element.getBoundingClientRect();
  return bounding.right > document.documentElement.clientWidth && bounding.left > bounding.width;
}; // Exec callback on next render frame


exports.needChangeSide = needChangeSide;

var onNextFrame = function onNextFrame(callback) {
  window.requestAnimationFrame(function () {
    return window.requestAnimationFrame(callback);
  });
};

exports.onNextFrame = onNextFrame;

var isClientSide = function isClientSide() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

exports.isClientSide = isClientSide;